import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { useState, SyntheticEvent } from "react";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  item: any;
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

interface TabPanelProps2 {
  children?: React.ReactNode;
  elem: any;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps2) {
  const { elem, value, index, ...other } = props;

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
      }}
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            mt: {
              xs: 2,
              md: 0,
            },
            display: "flex",
            flexDirection: "row",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
            minWidth: {
              xs: "200px",
              md: "300px",
              lg: "400px",
            },
          }}
        >
          <Card
            sx={{
              width: "100%",
              borderRadius: 2,
              border: "3px solid var(--c-bg-content-color)",
              height: {
                xs: "360px",
                sm: "360px",
                md: "296px",
                lg: "348px",
              },
              display: "flex",
              flexDirection: "column",
              boxShadow: "var(--c-box-shadow-btn)",
              backgroundColor: "var(--c-bg-content-color)",
            }}
          >
            <CardMedia
              height="200px"
              component="img"
              image={elem?.cover || ""}
              alt="green iguana"
            />
            <CardContent
              sx={{
                flexDirection: "column",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "var(--c-text-color)",
                scrollbarWidth: "thin",
                overflowY: "scroll",
              }}
            >
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={{
                  fontSize: { xs: "22px", sm: "24px", md: "24px" },
                  fontWeight: 700,
                  paddingTop: 2,
                }}
              >
                {elem?.label || ""}
              </Typography>
              <Typography
                component="div"
                sx={{
                  fontSize: { xs: "11px", sm: "12px", md: "13px" },
                  paddingBottom: 1,

                  fontWeight: 100,
                }}
              >
                {elem?.desc || ""}
              </Typography>
            </CardContent>
          </Card>
        </Box>
      )}
    </Box>
  );
}

export const CustomTabPanel = (props: TabPanelProps) => {
  const { item, value, index, ...other } = props;
  const [value2, setValue] = useState(0);

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box
      role="tabpanel"
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      sx={{
        width: "100%",
      }}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            p: 3,
            height: "420px",
            display: "flex",
            alignItems: "center",
            flexDirection: {
              xs: "column",
              md: "row",
            },
          }}
        >
          <Box sx={{ display: "flex", flex: 1 }}>
            <Tabs
              value={value2}
              onChange={handleChange}
              aria-label="Vertical tabs example"
              TabIndicatorProps={{
                sx: {
                  height: "0px",
                },
              }}
              sx={{
                transition: "all 0.3s ease-in-out",
                borderColor: "divider",
                display: "flex",
                color: "var(--c-text-color)",
                "& .MuiTabs-flexContainer": {
                  flexWrap: "wrap",
                  display: "flex",
                  justifyContent: {
                    xs: "center",
                    md: "start",
                  },
                },
              }}
            >
              {item?.list?.map((el: any, inx: number) => {
                const valBgColor = el?.value > 70 ? "#00972d" : el?.value < 31 ? "#F14C4C" : "#FFDD00";
                const valColor = el?.value > 70 ? "#FFFFFF" : el?.value < 31 ? "#000000" : "#000000";
                return(
                <Tab
                  component="div"
                  icon={
                    <>
                      <Box
                        alt={""}
                        component="img"
                        sx={{
                          filter: "grayscale(100%)",
                          height: {
                            xs: "15px",
                            sm: "20px",
                            md: "25px",
                            lg: "35px",
                          },
                          width: {
                            xs: "15px",
                            sm: "20px",
                            md: "25px",
                            lg: "35px",
                          },
                          "&.Mui-selected": {
                            backgroundColor: "var(--c-main-color-hover)",
                            color: "black",
                          },
                          "&.Mui-focusVisible": {
                            backgroundColor: "#d1eaff",
                          },
                        }}
                        src={el?.icon || ""}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: {
                            xs: "18px",
                            sm: "20px",
                            md: "24px",
                          },
                          height: {
                            xs: "18px",
                            sm: "20px",
                            md: "24px",
                          },
                          fontSize: {
                            xs: "8px",
                            md: "10px",
                          },
                          backgroundColor: valBgColor,
                          backdropFilter: "blur(10px)",
                          position: "absolute",
                          right: "-5px",
                          bottom: "-5px",
                          boxShadow:
                            "inset 2px 2px 5px 0px rgba(0,0,0,0.75), var(--c-box-shadow-outser-btn-1)",
                          borderRadius: "50%",
                          border: "2px solid var(--c-bg-content-color)",
                          transition: "all 0.3s ease-in-out",
                          color: valColor,
                          fontWeight: "bold",
                          "&:hover": {
                            fontSize: {
                              xs: "10px",
                              md: "12px",
                            },
                            width: {
                              xs: "15px",
                              sm: "20px",
                              md: "25px",
                              lg: "28px",
                            },
                            height: {
                              xs: "15px",
                              sm: "20px",
                              md: "25px",
                              lg: "28px",
                            },
                          },
                        }}
                      >
                        {el?.value || 50}
                      </Box>
                    </>
                  }
                  label={""}
                  sx={{
                    color: "var(--c-text-color)",
                    m: {
                      xs: 0.8,
                      sm: 1,
                      md: 1.5,
                      lg: 2,
                    },
                    padding: 0,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "30px",
                    boxShadow: "var(--c-box-shadow-btn)",
                    minWidth: {
                      xs: "40px",
                      sm: "45px",
                      md: "50px",
                      lg: "55px",
                      xl: "60px",
                    },
                    minHeight: {
                      xs: "40px",
                      sm: "45px",
                      md: "50px",
                      lg: "55px",
                      xl: "60px",
                    },
                    overflow: "visible !important",
                    transition: "all 0.3s ease-in-out",
                    border: "2px solid var(--c-bg-content-color)",
                    "&.Mui-selected": {
                      backgroundColor: "var(--c-main-color-hover)",
                      "& img": {
                        filter: "grayscale(0%)",
                      },
                    },
                    "&:hover": {
                      backgroundColor: "var(--c-main-color-hover)",
                      "& img": {
                        filter: "grayscale(0%)",
                      },
                    },
                  }}
                  {...a11yProps(inx)}
                />
              )})}
            </Tabs>
          </Box>
          <Box sx={{ display: "flex", flex: 1, width: "100%" }}>
            {item?.list?.map((el: any, inx: number) => (
              <TabPanel value={value2} index={inx} elem={el} />
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};
